import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type Company from 'garaje/models/company';
import type GlobalFlow from 'garaje/models/global-flow';
import type { GlobalOverviewQuestionnairesRouteModel } from 'garaje/pods/location-overview/questionnaires/route';
import type StateService from 'garaje/services/state';

export type GlobalOverviewQuestionnairesIndexRouteModel = {
  company: Company;
  flows: GlobalFlow[];
};

export default class GlobalOverviewQuestionnairesIndexRoute extends Route {
  @service declare state: StateService;

  model(): GlobalOverviewQuestionnairesIndexRouteModel {
    const { flows } = <GlobalOverviewQuestionnairesRouteModel>this.modelFor('location-overview.questionnaires');
    return {
      company: this.state.currentCompany,
      flows,
    };
  }
}
